import { dropBoolean } from 'utils/drops';

const getCidadeFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'localidade', label: 'Localidade', initial: true },
  {
    name: 'sigla',
    label: 'Sigla',
    type: 'select',
    options: drops?.UF,
    multiple: true,
  },
  { name: 'cepbase', label: 'CEP Base' },
  { name: 'codigo_ibge', label: 'Código IBGE', type: 'number' },
  {
    name: 'livrecom',
    label: 'Livre Comércio',
    type: 'select',
    options: dropBoolean,
  },
  { name: 'codmunicipio', label: 'Código do Município', type: 'number' },
];

export default getCidadeFilterFields;
